package com.example.mystybag.appCore.logic

import com.example.mystybag.core.defines.UtilsDateDefines.DATE_FORMAT_DD_MMM_YYYY
import com.example.mystybag.core.defines.UtilsDateDefines.DATE_FORMAT_YYYY_DASH_MM_DASH_DD
import com.example.mystybag.core.expected.DateTimeHelper
import com.example.mystybag.core.expected.sendEmailToSupportWithBodyExtra
import com.example.mystybag.core.extensions.separate
import com.example.mystybag.core.extensions.toDateInstant
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.appCore.model.NotificationsUIState
import com.example.mystybag.appCore.model.NotificationsVisualModel.Companion.mapToVisualisationModel
import com.example.mystybag.sharedmodels.mystyBag.responseModels.NotificationModel
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atStartOfDayIn
import kotlinx.datetime.plus
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime

class NotificationsViewModel(context: AppContext): ChildViewModel<NotificationsUIState>(
    context         = context,
    uiData          = NotificationsUIState()
) {
    private var allNotifications = listOf<NotificationModel>()

    override fun onCreate() {
        navControls.isVisible = false
    }

    override fun onSearchTextChanged(search: String) {
        val list = updateNotificationsList()
        updateState { state -> state.copy(notifications = list) }
    }

    private fun updateNotificationsList(
        startDate   : Long? = uiState.value.selectedStartDate,
        endDate     : Long? = uiState.value.selectedEndDate
    ) = run {
        var previousNotification: NotificationModel? = null
        allNotifications.mapNotNull { notification ->
            if (
                (searchControls.state.searchText.value.isEmpty() || notification.message.contains(searchControls.state.searchText.value, true)) &&
                (startDate == null || endDate == null || LocalDateTime.parse(notification.date.replace(" ", "T"), LocalDateTime.Formats.ISO).toInstant(TimeZone.UTC).toEpochMilliseconds() in startDate ..endDate)
            )
                mapToVisualisationModel(notification, previousNotification).also { previousNotification = notification }
            else
                null
        }
    }

    fun onEmailLinkClicked() {
        sendEmailToSupportWithBodyExtra("")
    }

    fun onFilterButtonClicked() {
        updateState { state -> state.copy(showDatePickerDialog = true) }
    }

    fun dismissDialog() {
        updateState { state -> state.copy(showDatePickerDialog = false) }
    }

    fun onRemoveFiltrationClicked() {
        val list = updateNotificationsList(null, null)

        updateState { state ->
            state.copy(
                selectedStartDate       = null,
                selectedEndDate         = null,
                filteredDates           = null,
                notifications           = list
            )
        }
    }

    fun onDateSelected(startDateMillis: Long?, endDateMillis: Long?) {
        if ((startDateMillis != uiState.value.selectedStartDate || endDateMillis != uiState.value.selectedEndDate) && startDateMillis != null) {
            val startDate       = startDateMillis.toDateInstant().toLocalDateTime(TimeZone.currentSystemDefault()).date
            val endDate         = endDateMillis?.toDateInstant()?.toLocalDateTime(TimeZone.currentSystemDefault())?.date ?: startDate
            val list            = updateNotificationsList(startDateMillis, endDateMillis ?: startDate.plus(DatePeriod(days = 1)).atStartOfDayIn(TimeZone.currentSystemDefault()).toEpochMilliseconds())
            val filteredDates   =
                if (startDate == endDate)
                    DateTimeHelper.formatDate(startDate.toString(), DATE_FORMAT_YYYY_DASH_MM_DASH_DD, DATE_FORMAT_DD_MMM_YYYY)
                else
                    DateTimeHelper.formatDate(startDate.toString(), DATE_FORMAT_YYYY_DASH_MM_DASH_DD, DATE_FORMAT_DD_MMM_YYYY)
                        .separate("-")
                        .separate(DateTimeHelper.formatDate(endDate.toString(), DATE_FORMAT_YYYY_DASH_MM_DASH_DD, DATE_FORMAT_DD_MMM_YYYY))

            updateState { state ->
                state.copy(
                    showDatePickerDialog    = false,
                    selectedStartDate       = startDateMillis,
                    selectedEndDate         = endDateMillis ?: startDate.plus(DatePeriod(days = 1)).atStartOfDayIn(TimeZone.currentSystemDefault()).toEpochMilliseconds(),
                    notifications           = list,
                    filteredDates           = filteredDates
                )
            }
        } else
            updateState { state -> state.copy(showDatePickerDialog = false) }
    }
}